import React from 'react';
import { CTAButton, TrustSignals } from './Shared';
export const HeroSection = () => {
  return <section className="bg-biosync py-10 px-5 sm:px-10" data-id="element-139">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-140">
        <div className="inline-block bg-white/20 text-white font-bold uppercase text-xs tracking-wider py-1.5 px-4 rounded-full mb-8" data-id="element-141">
          ⚡ BIO-SYNC™
        </div>

        <h1 className="text-white font-bold sm:text-5xl md:text-[56px] mb-6 max-w-4xl mx-auto text-[28px]" data-id="element-142">
          Sistema emocional completo
        </h1>

        <div className="relative mx-auto mb-10 mt-2 max-w-md sm:max-w-lg" data-id="element-143">
          {/* Soft radial glow behind the floating mockup for depth on the green hero */}
          <div aria-hidden="true" className="absolute inset-0 -m-8 rounded-full blur-3xl opacity-50" style={{
          background: 'radial-gradient(closest-side, rgba(255,255,255,0.45), rgba(16,163,127,0) 70%)'
        }} data-id="element-144" />
          <img src="https://cdn.magicpatterns.com/uploads/orBssgZxFdtPFRH6g8kBAu/bio_sync_optimized_2.webp" alt="BIO-SYNC: Sistema completo con ebook, módulos, fichas y acceso móvil" width={500} height={500} loading="eager" decoding="async"
        // @ts-ignore: fetchpriority is a valid HTML attribute, typings vary
        fetchpriority="high" className="relative w-full h-auto drop-shadow-2xl mt-[-40px] mb-[-40px]" data-id="element-145" />
        </div>

        <p className="text-white/90 sm:text-lg max-w-2xl mx-auto mb-10 text-[14px]" data-id="element-146">
          "El sistema completo de regulación emocional para adolescentes de 11 a
          18 años: ansiedad, impulsividad, autoestima, límites y conexión. Sin
          improvisar. Sin esperar que el tiempo lo resuelva."
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-147">
          {['📄 PDF Digital', '⚡ Acceso Inmediato', '👤 11 a 18 años', '💥 Sistema Completo'].map((badge, i) => <span key={i} className="bg-white text-biosync font-bold uppercase text-xs py-2 px-4 rounded-full" data-id="element-148">
              {badge}
            </span>)}
        </div>

        <CTAButton variant="white" href="#precio" data-id="element-149">
          → QUIERO EL SISTEMA BIO-SYNC
        </CTAButton>

        <TrustSignals variant="light" data-id="element-150" />
      </div>
    </section>;
};